{
  "nav": {
    "dashboard": "لوحة التحكم",
    "articles": "المقالات",
    "authors": "الكُتّاب",
    "media": "الوسائط",
    "analytics": "الإحصائيات",
    "settings": "الإعدادات",
    "logout": "تسجيل الخروج"
  },
  "articles": {
    "title": "المقالات",
    "newArticle": "مقال جديد",
    "editArticle": "تعديل المقال",
    "drafts": "مسودات",
    "inReview": "قيد المراجعة",
    "published": "منشور",
    "archived": "مؤرشفة",
    "status": "الحالة",
    "category": "التصنيف",
    "language": "اللغة",
    "author": "الكاتب",
    "updated": "آخر تحديث",
    "actions": "إجراءات",
    "noArticles": "لا توجد مقالات بعد",
    "deleteConfirm": "هل أنت متأكد من حذف هذا المقال؟"
  },
  "editor": {
    "step1": "العنوان والرابط",
    "step2": "المحتوى",
    "step3": "الوسائط",
    "step4": "الشارات والبيانات الوصفية",
    "step5": "الوصول والتبرعات",
    "step6": "المراجعة والنشر",
    "saveDraft": "حفظ المسودة",
    "submitReview": "تقديم للمراجعة",
    "publish": "نشر",
    "archive": "أرشفة",
    "requestChanges": "طلب تعديلات",
    "approve": "موافقة",
    "step5AccessLabel": "مستوى الوصول",
    "step5AccessDesc": "جميع المقالات مجانية ومتاحة لجميع القراء في الإصدار الأول. المحتوى المقيد أو المخصص للمشتركين غير متوفر بعد.",
    "step5DonationLabel": "دعم القراء",
    "step5DonationDesc": "يدعم القراء Beyond Silence عبر Buy Me a Coffee. يظهر رابط التبرع في نهاية كل مقال منشور. لا يتطلب الأمر اشتراكًا أو نظام حظر."
  },
  "dashboard": {
    "title": "لوحة التحكم",
    "publishedCount": "المقالات المنشورة",
    "totalViews": "إجمالي المشاهدات",
    "totalDonations": "إجمالي التبرعات",
    "avgReadTime": "متوسط وقت القراءة",
    "topArticles": "أفضل المقالات",
    "topAuthors": "أفضل الكُتّاب",
    "dateRange": "الفترة الزمنية",
    "filter": "تصفية"
  }
}
